import React, { Fragment } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  dialog: {
    width: '500px',
    '@media (max-width: 800px)': {
      width: 'auto',
    },
  },
  textItem: {
    fontSize: '14px',
  },
  separator: {
    height: 1,
    backgroundColor: 'lightgray',
    marginBottom: 8,
    marginTop: 8,
  },
});

interface ContractorHistoryDialogProps {
  handleClose: () => void;
  open: boolean;
  selectedJobPhase: any;
}

export const ContractorHistoryDialog: React.FC<ContractorHistoryDialogProps> = ({
  handleClose,
  open,
  selectedJobPhase,
}) => {
  const classes = useStyles();

  const sortPhases = (a: any, b: any) =>
    new Date(a.createdAt) < new Date(b.createdAt) ? -1 : 1;

  if (!selectedJobPhase) {
    return <Fragment />;
  }

  const sortedPhases = selectedJobPhase.jobPhaseContractorHistories
    ? selectedJobPhase.jobPhaseContractorHistories.sort(sortPhases)
    : [];

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="contractor-history-dialog-title"
      aria-describedby="contractor-history-dialog-description"
      maxWidth="sm"
    >
      <DialogTitle id="contractor-history-dialog-title">
        Contractor History
      </DialogTitle>
      <DialogContent className={classes.dialog}>
        <Box display="flex" justifyContent="space-between">
          <Box width="30%">
            <Typography>Override Contractor</Typography>
          </Box>
          <Box width="30%">
            <Typography>Approval Manager</Typography>
          </Box>
          <Box width="30%">
            <Typography>Time Stamp</Typography>
          </Box>
        </Box>
        <Box className={classes.separator} />
        {sortedPhases.map((itemHistory: any, index: number) => (
          <Fragment key={itemHistory.id || index}>
            <Box
              display="flex"
              width="100%"
              justifyContent="space-between"
            >
              <Box width="30%">
                <Typography className={classes.textItem}>
                  {itemHistory.contractor?.name || 'Unknown Contractor'}
                </Typography>
              </Box>
              <Box width="30%">
                <Typography className={classes.textItem}>
                  {itemHistory.assigningUser
                    ? `${itemHistory.assigningUser.firstName} ${itemHistory.assigningUser.lastName}`
                    : 'System'}
                </Typography>
              </Box>
              <Box width="30%">
                <Typography className={classes.textItem}>
                  {index === 0
                    ? 'Original'
                    : itemHistory.updatedAt
                    ? `${new Date(
                        itemHistory.updatedAt,
                      ).toLocaleDateString()}-${new Date(
                        itemHistory.updatedAt,
                      ).toLocaleTimeString()}`
                    : 'Unknown Date'}
                </Typography>
              </Box>
            </Box>
            {index !== sortedPhases.length - 1 && (
              <Box className={classes.separator} />
            )}
          </Fragment>
        ))}
        <Box display="flex" justifyContent="flex-end" mt={3}>
          <Button onClick={handleClose} color="primary">
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ContractorHistoryDialog;